import { render } from "./formouvrirdoc.vue?vue&type=template&id=f45a5308&scoped=true"
import script from "./formouvrirdoc.vue?vue&type=script&lang=js"
export * from "./formouvrirdoc.vue?vue&type=script&lang=js"

import "./formouvrirdoc.vue?vue&type=style&index=0&id=f45a5308&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f45a5308"]])

export default __exports__